interface Props {
  query: string;
}

export function EmptyState({ query }: Props) {
  return (
    <div className="ss-empty">
      <div className="ss-empty__mark">⌕</div>
      <h2 className="ss-empty__title">검색 결과가 없어요</h2>
      <p className="ss-empty__sub">
        {query
          ? <>“<b>{query}</b>” 와(과) 일치하는 영상이 없습니다.</>
          : '필터 조건에 맞는 영상이 없습니다.'}
        <br />다른 키워드로 다시 시도하거나 필터를 초기화해 보세요.
      </p>
    </div>
  );
}
